'use client';
/* Built In Imports */
import { createContext, useState } from 'react';

/* External Imports */
/* Internal Imports */
/* Components */

/* Services */

export const SamskritiContext = createContext();

const SamskritiContextProvider = ({ children }) => {
  const [localPaths, setLocalPaths] = useState('in');
  const [workshopDetails, setWorkshopDetails] = useState('');
  const [chantsDetails, setChantsDetails] = useState('');
  const [nirvana, setNirvana] = useState('');
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(313);

  // useEffect(() => {
  //   (async () => {
  //     /* Logging the value of landingPaths and landingPaths?.country.toLowerCase() */
  //     let cRegion;
  //     console.log(id, "context")
  //     try {
  //       setId(id)
  //       setLoading(true);
  //       cRegion = await getCurrentRegion();
  //       setLocalPaths(cRegion?.country?.toLowerCase());

  //       /* Set WorkshopDetails context to api data */
  //       const upcomingWorkShope = await fetchUpcomingWorkShop(id);
  //       setWorkshopDetails(upcomingWorkShope);

  //       /* Set chantsDetails context to api data */
  //       const chants = await fetchChantsDetails(id);
  //       setChantsDetails(chants);

  //       /* Set nirvana context to api data */
  //       const nirvanaDetails = await fetchNirvanaDetails(id);
  //       setNirvana(nirvanaDetails);

  //     } catch (err) {
  //       console.error('err', err);
  //       setLoading(false);
  //     } finally {
  //       if (cRegion?.length === 0) {
  //         setLocalPaths('in');
  //       }
  //     }
  //   })();
  // }, []);

  const workShopUserDetails = {
    workshopDetails,
    setWorkshopDetails,
    localPaths,
    loading,
    chantsDetails,
    nirvana,
    id,
    setId,
  };

  return (
    <SamskritiContext.Provider value={workShopUserDetails}>
      {children}
    </SamskritiContext.Provider>
  );
};

export default SamskritiContextProvider;
